import Banner from "../components/privacyPolicy/Banner";
import PrivacyContent from "../components/privacyPolicy/PrivacyContent";

export default function PrivacyPolicy() {
  return (
    <>
      <Banner />
      <PrivacyContent />
    </>
  );
}
